import { Component, OnInit, Input, Output, ViewChild, SimpleChanges, EventEmitter } from '@angular/core';
import { DbService } from '../../services/db.service'
import { Subscription } from 'rxjs'
import * as uuid from 'uuid/v1'
import notify from 'devextreme/ui/notify'
import IntervalTree from 'node-interval-tree'

@Component({
  selector: 'app-booking-grid',
  templateUrl: './booking-grid.component.html',
  styleUrls: ['./booking-grid.component.css']
})
export class BookingGridComponent implements OnInit {

  @Input() booking
  @Input() bookings
  @Input() bookingObjects
  @Input() webBlocks
  @Input() ai

  @Output() addBi = new EventEmitter()

  @ViewChild('outer') outer

  objects = []
  objectCount = 0
  items = []
  slotLines = []

  gridDim = { lo: 80, ro: 20, to: 40, bo: 10, start: 0, end: 0, ppm: 1, hourArray: [] }

  busSubscription: Subscription

  constructor(private db: DbService) { 

    this.busSubscription = this.db.msgBusGetMessage().subscribe(message => {

      //if (this.db.debug) console.log("booking-grid msgBus incoming message", message);

      if (message.text == "bookingschanged") setTimeout(() => { 
        this.createItems() 
        this.dimChange()
      }, 200)

      if (message.text == "cancel") {
        this.createItems()
      }

    })

  }

  ngOnInit() {
    //this.createObjects()
    //this.createItems()
    this.dimChange()
  }

  ngOnDestroy() {
    this.busSubscription.unsubscribe()
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => { 
      this.createObjects()
      this.createItems()
    }, 200)
  }

  dimChange() {
    this.gridDim.start = this.ai.open
    this.gridDim.end = this.ai.close
    for (var n = 0; n < this.ai.close - this.ai.open; n += 60) this.gridDim.hourArray.push(n)
    this.gridDim.ppm = (this.outer.nativeElement.clientWidth - this.gridDim.lo - this.gridDim.ro) / (this.ai.close - this.ai.open)
  }

  createObjects() {
    this.objects = []
    var row = 0
    //var rname = this.db.getResource(this.resourceToShow.idResource, this.resources).name
    //var rname = 'Bana'
    this.bookingObjects.filter(bo => bo.webbookable && !bo.disabled && bo.idResource == this.ai.resource.id).sort(function (a, b) { if (a.sortindex < b.sortindex) return -1; if (a.sortindex > b.sortindex) return 1; return 0; }).forEach(bo => {
      bo["row"] = row++
      //bo["fullname"] = rname + " " + bo.number
      bo["fullname"] = this.ai.resource.unit + " " + bo.number
      this.objects.push(bo)
    })
    this.objectCount = this.objects.length
    //console.log('createObjects', this.objects)
  }

  createItems() {
    this.items = [];
    this.bookings.filter(b => !b.deleted).forEach(b => {
      b.bookingItems.filter(bi => bi.idResource == this.ai.resource.id).forEach(bi => {
        var row = -1;
        var webbookable = false
        this.objects.filter(o => o.id == bi.idBookingObject).forEach(bo => { 
          row = bo.row 
          webbookable = true
        });
        if (webbookable) this.items.push({ row: row, namn: 'Upptagen', start: bi.start, duration: bi.duration, id: bi.id, bid: b.id, idResource: bi.idResource, tableid: bi.idResource, status: bi.status });

      });
    });
     

    this.webBlocks.filter(wb => wb.idResource == this.ai.resource.id).forEach(wb => {
      //console.log(wb)
      this.objects.forEach(o => {
        //console.log(bo)
        this.items.push({ row: o.row, namn: 'Upptagen', start: wb.time, duration: +this.ai.resource.interval, id: '2', bid: '2', idResource: '2', tableid: '2', status: 0 });
      })
    })

    if (this.db.system == 'biljardbaren') {
      this.slotLines = []
      for (var n = this.ai.open + +this.ai.resource.interval; n < this.ai.close; n += +this.ai.resource.interval) {
        this.slotLines.push(n)
      }  
    }

    
  }

  clickBg(evt, idbo) {

    var x = evt.clientX - this.outer.nativeElement.getBoundingClientRect().left;
    x = (x - this.gridDim.lo) / this.gridDim.ppm + this.gridDim.start

    var closestInterval = 0
    for (var n = this.ai.open; n < this.ai.close; n += +this.ai.resource.interval) {
      if (n <= x) closestInterval = n
    }
    if (closestInterval == 0 ) return

    x = closestInterval

    // Check Karens
    var d = new Date()
    var karens = +this.db.setting.karens
    if (this.ai.resource.webkarens) karens = this.ai.resource.webkarens

    if (this.db.isToday() && x < d.getHours() * 60 + d.getMinutes() + karens) {
      notify('Denna tid kan inte bokas nu', 'error', 2000)
      return
    }

    // Check for overlaps
    var ivt = new IntervalTree()
    this.bookings.forEach(b => {
      b.bookingItems.filter(bi => bi.idResource == this.ai.resource.id).forEach(bi => {
        if (bi.start + bi.duration + +this.ai.resource.cleaningtime - 1 > bi.start) ivt.insert(bi.start, bi.start + bi.duration + +this.ai.resource.cleaningtime - 1, bi.idBookingObject)
        //console.log('ivt', bi.start, bi.start + bi.duration - 1, bi.idBookingObject)
      })
    })
    if (ivt.search(x, x + +this.ai.resource.defaultduration - 1).filter(i => i == idbo).length) {
      //console.log('Overlap')
      return
    }

    // Check for overlaps within own booking
    var ivt = new IntervalTree()
    this.booking.bookingItems.filter(bi => bi.idResource != this.ai.resource.id).forEach(bi => {
      if (bi.start + bi.duration - 1 > bi.start) ivt.insert(bi.start, bi.start + bi.duration - 1, bi.idBookingObject)
    })
    if (ivt.search(x, x + +this.ai.resource.defaultduration - 1).length) {
      notify('Vald tid överlappar annan aktivitet', 'error', 2000)
      return
    }

    // Check if max number of bookingObjects is reached
    if (this.booking.bookingItems.filter(bi => bi.idResource == this.ai.resource.id).length >= +this.ai.resource.csi) {
      notify('Max antal bokade objekt upnått', 'error', 2000)
      return
    }

    // Check if we should extend existing booking
    var ret = false
    if (this.db.system == 'biljardbaren') {
      
      this.booking.bookingItems.filter(bi => bi.idBookingObject == idbo).forEach(bi => {
        
        if (bi.start + bi.duration + 15 == x) {
          
          bi.duration += +this.ai.resource.defaultduration
          this.db.collapseBookingItems(this.booking, this.bookingObjects)
          this.createItems()
          ret = true

        }

      })
      
    }
    if (ret) return
    
    if (x + (+this.ai.resource.defaultduration) > this.ai.close) return

    this.booking.bookingItems.push({
      id: uuid(),
      idBookingObject: idbo,
      idResource: this.ai.resource.id,
      start: x,
      duration: +this.ai.resource.defaultduration,
      status: 0,
      persons: 0,
      price: 0,
      vat: 0
    })

    this.addBi.emit()
    this.db.collapseBookingItems(this.booking, this.bookingObjects)
    this.createItems()
    
  }

  clickItem(item) {
    
    if (item.bid != this.booking.id) return

    this.booking.bookingItems = this.booking.bookingItems.filter(bi => bi.id != item.id)
    this.db.collapseBookingItems(this.booking, this.bookingObjects)
    this.createItems()    

  }

  evenHour(close) {
    if (close / 60 == Math.floor(close / 60)) return true
    return false
  }
  

}
